import { BASE_URL } from '@/config/common'
import { FetchProductParams } from '@/helpers/types/params_body/FetchProductParams'
import { ProductDetails } from '@/helpers/types/ProductDetails'
import { ApiResponse, Product } from '@/types/api'

export const fetchProducts = async (): Promise<ApiResponse<Product[]>> => {
  const response = await fetch(`${BASE_URL}/products`)
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }

  const data = await response.json()
  console.log('fetchProducts->:', data)

  return data
}

export const fetchProductsByList = async (params: {
  sku_list: string[]
}): Promise<ApiResponse<Product[]>> => {
  const response = await fetch(`${BASE_URL}/products/list`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })

  if (!response.ok) {
    throw new Error('Failed to fetch products by list')
  }
  return response.json()
}

export const fetchProductById = async (
  id: number
): Promise<ApiResponse<ProductDetails>> => {
  const response = await fetch(`${BASE_URL}/getproducts/${id}`)
  if (!response.ok) {
    throw new Error('Network response was not ok')
  }
  return response.json()
}

const allowedSortOptions = [
  'low_to_high',
  'high_to_low',
  'new_to_old',
  'old_to_new',
  'a_to_z',
  'z_to_a',
] as const

const allowedPriceRangeTypes = ['under', 'between', 'above'] as const

export const fetchProductsByParams = async (
  params: FetchProductParams
): Promise<ApiResponse<Product[]>> => {
  const queryParams = new URLSearchParams()

  if (params.main_category)
    queryParams.append('main_category', params.main_category)
  if (params.metal_info) queryParams.append('metal_info', params.metal_info)
  if (params.subcategory) queryParams.append('subcategory', params.subcategory)

  if (params.sort_by && allowedSortOptions.includes(params.sort_by as any)) {
    queryParams.append('sort_by', params.sort_by)
  }

  if (params.color) queryParams.append('color', params.color)
  if (params.shape) queryParams.append('shape', params.shape)
  if (params.stock) queryParams.append('stock', params.stock)
  if (params.stoneType) queryParams.append('stoneType', params.stoneType)
  if (params.karat) queryParams.append('karat', params.karat)
  if (params.priceRange) queryParams.append('priceRange', params.priceRange)
  if (params.page) queryParams.append('page', params.page.toString())
  if (params.limit) queryParams.append('limit', params.limit.toString())

  if (
    params.priceRangeType &&
    allowedPriceRangeTypes.includes(params.priceRangeType as any)
  ) {
    queryParams.append('priceRangeType', params.priceRangeType)
  }

  const url = `${BASE_URL}/products?${queryParams.toString()}`

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) throw new Error('Network response was not ok')
  return response.json()
}

export const fetchSimilarProducts = async (
  id: number
): Promise<ApiResponse<Product[]>> => {
  const response = await fetch(`${BASE_URL}/products/similar/${id}`)

  if (!response.ok) {
    throw new Error('Failed to fetch products by list')
  }
  return response.json()
}

export const fetchProductsPlacement = async (
  displayPage: string
): Promise<ApiResponse<Product[]>> => {
  const response = await fetch(
    `${BASE_URL}/products/placement?display_page=${displayPage}`
  )

  // if (!response.ok) {
  //   throw new Error("Failed to fetch products by list");
  // }
  return response.json()
}

export const fetchProductByCategory = async (
  query: string
): Promise<ApiResponse<Product[]>> => {
  const response = await fetch(`${BASE_URL}/products?subcategory=${query}`)

  return response.json()
}
